// Export country groups with trade zone info
export const EXPORT_COUNTRIES = {
  EU: {
    label: { fr: 'Accord préférentiel UE — Droits réduits', ar: 'اتفاقية تفضيلية مع الاتحاد الأوروبي — رسوم مخفضة' },
    badge: { fr: 'Accord UE', ar: 'اتفاقية UE' },
    color: '#10b981',
    countries: [
      {code:'FR',fr:'France',ar:'فرنسا'},{code:'IT',fr:'Italie',ar:'إيطاليا'},{code:'ES',fr:'Espagne',ar:'إسبانيا'},
      {code:'DE',fr:'Allemagne',ar:'ألمانيا'},{code:'PT',fr:'Portugal',ar:'البرتغال'},{code:'NL',fr:'Pays-Bas',ar:'هولندا'},
      {code:'BE',fr:'Belgique',ar:'بلجيكا'},{code:'GR',fr:'Grèce',ar:'اليونان'},{code:'PL',fr:'Pologne',ar:'بولندا'},
      {code:'AT',fr:'Autriche',ar:'النمسا'},{code:'SE',fr:'Suède',ar:'السويد'},{code:'CZ',fr:'Rép. Tchèque',ar:'التشيك'},
      {code:'RO',fr:'Roumanie',ar:'رومانيا'},{code:'HU',fr:'Hongrie',ar:'المجر'},{code:'SK',fr:'Slovaquie',ar:'سلوفاكيا'},
      {code:'SI',fr:'Slovénie',ar:'سلوفينيا'},{code:'HR',fr:'Croatie',ar:'كرواتيا'},{code:'BG',fr:'Bulgarie',ar:'بلغاريا'},
      {code:'DK',fr:'Danemark',ar:'الدنمارك'},{code:'FI',fr:'Finlande',ar:'فنلندا'},{code:'IE',fr:'Irlande',ar:'أيرلندا'},
      {code:'LT',fr:'Lituanie',ar:'ليتوانيا'},{code:'LV',fr:'Lettonie',ar:'لاتفيا'},{code:'EE',fr:'Estonie',ar:'إستونيا'},
      {code:'CY',fr:'Chypre',ar:'قبرص'},{code:'MT',fr:'Malte',ar:'مالطا'},{code:'LU',fr:'Luxembourg',ar:'لوكسمبورغ'},
    ]
  },
  GZALE: {
    label: { fr: 'Zone GZALE — Exonération droits', ar: 'منطقة التبادل الحر العربية — إعفاء من الرسوم' },
    badge: { fr: 'GZALE', ar: 'المنطقة العربية' },
    color: '#f59e0b',
    countries: [
      {code:'TN',fr:'Tunisie',ar:'تونس'},{code:'MA',fr:'Maroc',ar:'المغرب'},{code:'LY',fr:'Libye',ar:'ليبيا'},
      {code:'MR',fr:'Mauritanie',ar:'موريتانيا'},{code:'EG',fr:'Égypte',ar:'مصر'},{code:'JO',fr:'Jordanie',ar:'الأردن'},
      {code:'SA',fr:'Arabie Saoudite',ar:'المملكة العربية السعودية'},{code:'AE',fr:'Émirats Arabes Unis',ar:'الإمارات'},
      {code:'QA',fr:'Qatar',ar:'قطر'},{code:'KW',fr:'Koweït',ar:'الكويت'},{code:'BH',fr:'Bahreïn',ar:'البحرين'},
      {code:'OM',fr:'Oman',ar:'عُمان'},{code:'IQ',fr:'Irak',ar:'العراق'},{code:'LB',fr:'Liban',ar:'لبنان'},
      {code:'SY',fr:'Syrie',ar:'سوريا'},{code:'SD',fr:'Soudan',ar:'السودان'},{code:'YE',fr:'Yémen',ar:'اليمن'},
      {code:'PS',fr:'Palestine',ar:'فلسطين'},
    ]
  },
  OTHER: {
    label: { fr: 'Autres pays — Droit commun', ar: 'بلدان أخرى — النظام العام' },
    badge: { fr: 'Droit commun', ar: 'النظام العام' },
    color: '#94A3B8',
    countries: [
      {code:'TR',fr:'Turquie',ar:'تركيا'},{code:'GB',fr:'Royaume-Uni',ar:'المملكة المتحدة'},{code:'CH',fr:'Suisse',ar:'سويسرا'},
      {code:'CN',fr:'Chine',ar:'الصين'},{code:'US',fr:'États-Unis',ar:'الولايات المتحدة'},{code:'CA',fr:'Canada',ar:'كندا'},
      {code:'IN',fr:'Inde',ar:'الهند'},{code:'JP',fr:'Japon',ar:'اليابان'},{code:'KR',fr:'Corée du Sud',ar:'كوريا الجنوبية'},
      {code:'BR',fr:'Brésil',ar:'البرازيل'},{code:'MX',fr:'Mexique',ar:'المكسيك'},{code:'ZA',fr:'Afrique du Sud',ar:'جنوب أفريقيا'},
      {code:'SN',fr:'Sénégal',ar:'السنغال'},{code:'ML',fr:'Mali',ar:'مالي'},{code:'CI',fr:"Côte d'Ivoire",ar:'ساحل العاج'},
      {code:'GN',fr:'Guinée',ar:'غينيا'},{code:'NG',fr:'Nigéria',ar:'نيجيريا'},{code:'GH',fr:'Ghana',ar:'غانا'},
      {code:'CM',fr:'Cameroun',ar:'الكاميرون'},{code:'CD',fr:'RD Congo',ar:'الكونغو الديمقراطية'},
      {code:'ID',fr:'Indonésie',ar:'إندونيسيا'},{code:'VN',fr:'Vietnam',ar:'فيتنام'},
      {code:'TH',fr:'Thaïlande',ar:'تايلاند'},{code:'AU',fr:'Australie',ar:'أستراليا'},
    ]
  }
};

export const EXPORT_ACTIVITY_CODES = [
  { code: '701.101', fr: 'Produits agroalimentaires (frais, réfrigérés, surgelés)', ar: 'منتجات غذائية زراعية (طازجة، مبردة، مجمدة)' },
  { code: '702.101', fr: 'Produits industriels manufacturés (hors hydrocarbures)', ar: 'منتجات صناعية مصنعة (خارج المحروقات)' },
  { code: '702.102', fr: 'Autres produits hors hydrocarbures (plantes, animaux...)', ar: 'منتجات أخرى خارج المحروقات (نباتات، حيوانات...)' },
  { code: '702.103', fr: 'Produits pharmaceutiques et dispositifs médicaux', ar: 'منتجات صيدلانية وأجهزة طبية' },
  { code: '702.104', fr: 'Matériaux de construction', ar: 'مواد البناء' },
  { code: '702.105', fr: 'Électricité', ar: 'الكهرباء' },
  { code: '703.101', fr: 'Tous produits (code généraliste)', ar: 'جميع المنتجات (رمز عام)' },
  { code: '704.101', fr: 'Services numériques', ar: 'خدمات رقمية' },
  { code: '704.201', fr: 'Services liés au commerce', ar: 'خدمات مرتبطة بالتجارة' },
  { code: '704.202', fr: 'Services liés à l\'industrie', ar: 'خدمات مرتبطة بالصناعة' },
  { code: '705.101', fr: 'Déchets ménagers (DMA)', ar: 'نفايات منزلية' },
  { code: '705.102', fr: 'Déchets spéciaux (DS)', ar: 'نفايات خاصة' },
];

export const EXPORT_DEVISES = [
  { code: 'USD', label: 'USD — Dollar américain' },
  { code: 'EUR', label: 'EUR — Euro' },
  { code: 'GBP', label: 'GBP — Livre sterling' },
  { code: 'SAR', label: 'SAR — Riyal saoudien' },
  { code: 'AED', label: 'AED — Dirham émirati' },
  { code: 'DZD', label: 'DZD — Dinar algérien' },
  { code: 'TND', label: 'TND — Dinar tunisien' },
  { code: 'MAD', label: 'MAD — Dirham marocain' },
];

export function getCountryZone(code) {
  if (EXPORT_COUNTRIES.EU.countries.find(c => c.code === code)) return 'EU';
  if (EXPORT_COUNTRIES.GZALE.countries.find(c => c.code === code)) return 'GZALE';
  return 'OTHER';
}

export function getCountryName(code, lang) {
  const key = lang === 'ar' ? 'ar' : 'fr';
  for (const group of Object.values(EXPORT_COUNTRIES)) {
    const c = group.countries.find(x => x.code === code);
    if (c) return c[key];
  }
  return code;
}
